import { Wrapper } from 'AppReact';
import styled from 'styled-components';

let template = styled.div`
  display: flex; 
  align-items: center; 
  flex-grow: 1; 
  max-width: calc(100% - 90px);
`

export default Wrapper(template)